import _ from "lodash";
import React, { useEffect, useState } from "react";
import DebounceInput from "react-debounce-input";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert as Alert2, Button, Col, Input, Row } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { api } from "../utils";
import { ItemTypeahead, SpinnerButton, VendorTypeahead } from "./";

function ABCChecker(props) {
   return (
      <Row>
         <Col
            xs="4"
            onClick={() => props.onChange("A")}
            className="cursor-pointer"
         >
            <Input
               type="radio"
               className="me-1 radio-color"
               checked={props.checked === "A"}
               onChange={() => props.onChange("A")}
            />
            A
         </Col>
         <Col
            xs="4"
            onClick={() => props.onChange("B")}
            className="cursor-pointer"
         >
            <Input
               type="radio"
               className="me-1 radio-color"
               checked={props.checked === "B"}
               onChange={() => props.onChange("B")}
            />
            B
         </Col>
         <Col
            xs="4"
            onClick={() => props.onChange("C")}
            className="cursor-pointer"
         >
            <Input
               type="radio"
               className="me-1 radio-color"
               checked={props.checked === "C"}
               onChange={() => props.onChange("C")}
            />
            C
         </Col>
      </Row>
   );
}

export default function CreateMachinePartCode(props) {
   const [classOptions, setClassOptions] = useState([]);
   const [editItem, setEditItem] = useState({});
   const [itemClass, setItemClass] = useState(null);
   const [itemDescription, setItemDescription] = useState(null);
   const [itemNumber, setItemNumber] = useState(null);
   const [loading, setLoading] = useState(false);
   const [message, setMessage] = useState(null);
   const [referenceItem, setReferenceItem] = useState(null);
   const [refInfo, setRefInfo] = useState({});
   const [saving, setSaving] = useState(false);
   const [validBasicInfo, setValidBasicInfo] = useState(false);

   useEffect(() => {
      let apiCalls = [];
      apiCalls.push(
         api
            .post("Reference/GetItemClasses", { IsMachinePart: true })
            .then((response) => {
               return {
                  itemClassList: _.map(response.data?.itemClasses, (m) => {
                     m.value = m.id;
                     m.label = m.itemClassWithDesc;
                     return m;
                  }),
               };
            })
            .catch(api.catchHandler)
      );
      Promise.all(apiCalls)
         .then((arrayResults) => {
            let aggResults = {};
            _.each(arrayResults, (x) => Object.assign(aggResults, x));
            setClassOptions(
               aggResults.itemClassList ? aggResults.itemClassList : []
            );
         })
         .catch((error) =>
            setMessage({
               flavor: "alert-danger",
               text: "There was an error loading the drop down list data",
            })
         );
   }, []);

   useEffect(() => {
      setMessage(null);
      setValidBasicInfo(false);
      let changes = Object.assign({}, editItem);
      changes.referenceItem = referenceItem;
      changes.itemNumber = itemNumber;
      changes.itemDescription = itemDescription;
      changes.itemClass = itemClass;
      changes.standardCost = null;
      changes.currentCost = null;
      changes.listPrice = null;
      changes.minOrderQty = null;
      changes.shippingClass = null;
      changes.abcCode = null;
      changes.pltBin = null;
      changes.pltWhseBin = null;
      changes.vendor = null;
      changes.vendorItemNumber = null;
      changes.vendorItemDescription = null;
      changes.vendorPrice = null;
      changes.unitOfMeasure = null;
      setEditItem(changes);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [referenceItem, itemNumber, itemDescription, itemClass]);

   useEffect(() => {
      if (
         referenceItem &&
         (!refInfo || refInfo.value !== referenceItem.value) &&
         !loading
      ) {
         // escape the forward slash character or pound symbol if in the item so it won't mess up the URL
         // Example = MP.11/64S40007 this causes the url to look like it has an extra parameter because
         // of the / character so the URL is broken and a Not Found error is thrown.
         var encodedItem = referenceItem.value.replace(/\//g, '%2F').replace(/#/g, '%23');
         setLoading(true);
         api
            .fetch(`Item/GetItemInfo/${encodedItem}`)
            .then((res) => {
               if (res) {
                  let item = res?.data?.itemInfo;
                  item.value = item.itemNumber;
                  item.label = item.ddlText;
                  setRefInfo(item);
               }
            })
            .catch(api.catchHandler)
            .then(() => setLoading(false));
      }
   }, [referenceItem, refInfo, loading]);

   function clearEverything() {
      setMessage(null);
      setLoading(false);
      setSaving(false);
      setValidBasicInfo(false);
      setReferenceItem(null);
      setRefInfo({});
      setItemNumber("");
      setItemDescription("");
      setItemClass(null);
      setEditItem({});
   }

   function createNewItem() {
      let payload = {};
      // TO fix ABC code items, since not 1, 2, 3
      let abcValue = null;
      switch (editItem.abcCode) {
         case "A":
            abcValue = 2;
            break;
         case "B":
            abcValue = 3;
            break;
         case "C":
            abcValue = 4;
            break;
         default:
            break;
      }
      payload.ABCDisplayCode = abcValue;
      payload.CurrentCost = editItem.currentCost.trim();
      payload.BinLocationPLT = editItem.pltBin;
      payload.BinLocationWHSE = editItem.pltWhseBin;
      payload.CurrentCost = editItem.currentCost.trim();
      payload.ItemNumber = itemNumber.trim();
      payload.ItemDescription = itemDescription.trim();
      payload.ItemClass = itemClass?.itemClass;
      payload.ListPrice = editItem.listPrice.trim();
      payload.MinOrderQty = editItem.minOrderQty.trim();
      payload.StandardCost = editItem.standardCost.trim();
      payload.ShippingClass = editItem.shippingClass;
      payload.UnitPrice = editItem.unitPrice;
      payload.VendorUnitOfMeasure = editItem.unitOfMeasure;
      payload.VendorId = editItem.vendor.value;
      payload.VendorItemDescription = editItem.vendorItemDescription;
      payload.VendorPrice = editItem.vendorPrice.trim();
      payload.VendorItemNumber = editItem.vendorItemNumber;
      setSaving(true);
      api
         .post("Item/CreateMachinePartItem", payload)
         .then((res) => {
            if (res && res.data && res.data.success) {
               toast.success("New item created successfully");
               clearEverything();
            } else {
               toast.warning(res?.data?.message);
            }
         })
         .catch(api.catchHandler)
         .then(() => setSaving(false));
      setSaving(false);
   }

   async function getInitialWarnings() {
      let warnings = [];
      if (!itemNumber || itemNumber.length < 1) {
         warnings.push("Item number is required.");
      }
      if (!itemDescription || itemDescription.length < 1) {
         warnings.push("Item description is required.");
      }
      if (!itemClass) {
         warnings.push("Item class is required.");
      }
      return warnings;
   }

   function handleChanges(field, value) {
      let changes = Object.assign({}, editItem);
      changes[field] = value;
      setEditItem(changes);
   }

   async function validateFullItem() {
      let warnings = await getInitialWarnings();

      if (warnings.length) {
         setMessage({
            text: warnings.join(" "),
            flavor: "alert-danger",
         });
         setValidBasicInfo(false);
         return;
      } else {
         // second section validations
         if (!editItem.vendor) {
            warnings.push("Vendor is required.");
         }
         if (parseFloat(editItem.standardCost) < 0 || editItem.standardCost < 0) {
            warnings.push("Standard cost is required.");
         }
         if (parseFloat(editItem.currentCost) < 0 || editItem.currentCost < 0) {
            warnings.push("Current cost is required.");
         }
         if (parseFloat(editItem.vendorPrice) < 0 || editItem.vendorPrice < 0) {
            warnings.push("Vendor price is required.");
         }
         if (parseInt(editItem.minOrderQty, 10) < 1 || editItem.minOrderQty < 1) {
            warnings.push("Minimum order quantity is required.");
         }
         if (
            editItem.unitPrice &&
            (!parseFloat(editItem.unitPrice) < 0 || editItem.unitPrice < 0)
         ) {
            warnings.push("Unit price is required.");
         }
         if (warnings.length) {
            setMessage({
               text: warnings.join(" "),
               flavor: "alert-danger",
            });
         } else {
            createNewItem();
         }
      }
   }

   async function validateNewItem() {
      let warnings = await getInitialWarnings();
      if (warnings.length) {
         setMessage({
            text: warnings.join(" "),
            flavor: "alert-danger",
         });
         setValidBasicInfo(false);
         return;
      } else {
         setMessage(null);
         setValidBasicInfo(true);
         // will set defaults where possible
         if (refInfo) {
            let changes = Object.assign({}, editItem);
            changes.standardCost = refInfo.standardCost;
            changes.currentCost = refInfo.currentCost;
            changes.listPrice = refInfo.listPrice;
            changes.MinOrderQty = refInfo.minOrderQty;
            changes.shippingClass = refInfo.shippingClass;
            changes.abcCode = refInfo.abcDisplayCode;
            changes.vendor =
               refInfo.vendorId && refInfo.vendorName
                  ? {
                     label: refInfo.vendorName,
                     value: refInfo.vendorId,
                  }
                  : null;
            changes.vendorItemDescription = refInfo.vendorItemDescription;
            changes.vendorItemNumber = refInfo.vendorItemNumber;
            if (refInfo.unitOfMeasure) {
               changes.unitOfMeasure = refInfo.unitOfMeasure;
            }
            setEditItem(changes);
         }
      }
   }

   return (
      (document.title = `Create Machine Part Code`),
      (
         <DesktopContainer screenName="New Machine Part">
            {message ? (
               <Row className="mt-3">
                  <Col>
                     <Alert2 className={message.flavor}>{message.text}</Alert2>
                  </Col>
               </Row>
            ) : null}
            <div className="filter-header mb-3">
               <Row className="justify-content-center pe-3 text-center">
                  <Col xs={12}>
                     <h6 className="text-white mb-2">
                        Use the Reference Item field only for existing items you wish to
                        use as base information for the new item.
                     </h6>
                  </Col>
                  <Col xs={12}>
                     <Row className="align-items-center my-1">
                        <Col xs={2}>
                           <h5 children="Reference Item:" className="float-end text-white" />
                        </Col>
                        <Col xs={9}>
                           <ItemTypeahead
                              onChange={(e) => setReferenceItem(e)}
                              value={referenceItem}
                              placeholder="Select an EXISTING machine part item number or leave blank"
                              machinePartsOnly
                           />
                        </Col>
                     </Row>
                     <Row className="align-items-center my-1">
                        <Col xs={2}>
                           <h5 children="New Item Number:" className="float-end text-white" />
                        </Col>
                        <Col xs={9}>
                           <DebounceInput
                              type="text"
                              value={itemNumber}
                              onChange={(e) => { setItemNumber(e.target.value); }}
                              debounceTimeout={300}
                              className="float-start form-control"
                           />
                        </Col>
                     </Row>
                     <Row className="align-items-center my-1">
                        <Col xs={2}>
                           <h5 children="Item Description:" className="float-end text-white" />
                        </Col>
                        <Col xs={9}>
                           <DebounceInput
                              type="text"
                              value={itemDescription}
                              onChange={(e) => { setItemDescription(e.target.value); }}
                              debounceTimeout={300}
                              className="float-start form-control"
                           />
                        </Col>
                     </Row>
                     <Row className="align-items-center my-1">
                        <Col xs={2}>
                           <h5 children="Item Class:" className="float-end text-white" />
                        </Col>
                        <Col xs={3}>
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={classOptions}
                              value={itemClass}
                              onChange={setItemClass}
                              isClearable
                              components={makeAnimated()}
                           />
                        </Col>
                        <Col xs={{ size: "3", offset: "3" }}>
                           {validBasicInfo ? (
                              <Button
                                 className="float-end shredButton"
                                 children="Reset"
                                 disabled={loading || saving}
                                 onClick={clearEverything}
                              />
                           ) : (
                              <Button
                                 className="float-end shredButton"
                                 children="Continue"
                                 disabled={loading || saving}
                                 onClick={validateNewItem}
                              />
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </div>
            {validBasicInfo ? (
               <>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="Standard Cost:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.standardCost}
                           onChange={(e) => { handleChanges("standardCost", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                     <Col xs={2}>
                        <h5 children="Current Cost:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.currentCost}
                           onChange={(e) => { handleChanges("currentCost", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="List Price:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.listPrice}
                           onChange={(e) => { handleChanges("listPrice", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                     <Col xs={2}>
                        <h5 children="Min. Order Qty:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.minOrderQty ?? "0"}
                           onChange={(e) => { handleChanges("minOrderQty", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="Shipping Class:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <ABCChecker
                           checked={editItem?.shippingClass}
                           onChange={(choice) => handleChanges("shippingClass", choice)}
                        />
                     </Col>
                     <Col xs={2}>
                        <h5 children="ABC Code:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <ABCChecker
                           checked={editItem?.abcCode}
                           onChange={(choice) => handleChanges("abcCode", choice)}
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="Site ID:" className="float-end" />
                     </Col>
                     <Col xs={2}>
                        <h5 children="PLT Bin:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.pltBin}
                           onChange={(e) => { handleChanges("pltBin", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children={null} className="float-end" />
                     </Col>
                     <Col xs={2}>
                        <h5 children="PLTWHSE Bin:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.pltWhseBin}
                           onChange={(e) => { handleChanges("pltWhseBin", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="Vendor:" className="float-end" />
                     </Col>
                     <Col xs={8}>
                        <VendorTypeahead
                           value={editItem.vendor}
                           onChange={(selection) => { handleChanges("vendor", selection); }}
                           debounceTimeout={300}
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="Vendor Item:" className="float-end" />
                     </Col>
                     <Col xs={8}>
                        <DebounceInput
                           type="text"
                           value={editItem.vendorItemNumber}
                           onChange={(e) => { handleChanges("vendorItemNumber", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="Vendor Item Desc:" className="float-end" />
                     </Col>
                     <Col xs={8}>
                        <DebounceInput
                           type="text"
                           value={editItem.vendorItemDescription}
                           onChange={(e) => { handleChanges("vendorItemDescription", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-2">
                     <Col xs={2}>
                        <h5 children="Vendor Price:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.vendorPrice}
                           onChange={(e) => { handleChanges("vendorPrice", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                     <Col xs={2}>
                        <h5 children="Vendor UofM:" className="float-end" />
                     </Col>
                     <Col xs={3}>
                        <DebounceInput
                           type="text"
                           value={editItem.unitOfMeasure}
                           onChange={(e) => { handleChanges("unitOfMeasure", e.target.value); }}
                           debounceTimeout={300}
                           className="float-start form-control"
                        />
                     </Col>
                  </Row>
                  <Row className="align-items-center my-1">
                     <Col xs={7} />
                     <Col xs={"3"}>
                        <SpinnerButton
                           className="float-end shredButton"
                           children="Create Item"
                           disabled={loading || saving}
                           on={loading || saving}
                           onClick={validateFullItem}
                        />
                     </Col>
                  </Row>
               </>
            ) : null}
         </DesktopContainer>
      )
   );
}
